import EmailNotificationBaseService from 'services/notification/subServices/email/EmailNotificationBaseService';

import ResetPassEmailNotification from 'models/notification/email/ResetPassEmailNotification';

export default class ResetPassEmailNotificationService extends EmailNotificationBaseService {
	toModel(notification) {
		return new ResetPassEmailNotification(notification);
	}
}
